<template>
  <div
    class="box"
    :style="{
      marginTop: props.marginTop,
      marginBottom: props.marginBottom,
    }"
  >
    <!-- <img src="@/assets/img/empty.png" /> -->
    <p>资源内容正在整理中...</p>
  </div>
</template>

<script setup>
const props = defineProps({
  marginTop: {
    type: String,
    default: "0px",
  },
  marginBottom: {
    type: String,
    default: "0px",
  },
});
</script>

<style scoped lang="scss">
.box {
  // border: 1px solid #156085;
  background: #fff;
  border-radius: 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 0;
  padding: 150px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  > img {
    width: 100px;
    height: 100px;
  }
  > p {
    font-size: 20px;
    color: #bfbfbf;
  }
}
</style>
